import { useState } from "react";
import AxiosWrapper from "../../../basecomp/base/AxiosWrapper";
const { axiosGetCallHeaderWithToken } = AxiosWrapper;

const MCTDashboardVM = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState();
  const [error, setError] = useState(null);

  const handleStartDateChange = (date) => {
    setStartDate(date);
    setError(null);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    setError(null);
  };

  // Function to download the dashboard
  const getDownloadMaterialDashboard = async (
    formattedStartDate,
    formattedEndDate,
  ) => {
    try {
      // Construct the API URL and log it
      const apiUrl = `/mct/downloadMaterialDashboard?startDate=${formattedStartDate}&endDate=${formattedEndDate}`;

      // Make sure we're requesting the correct response type for Excel files
      const response = await axiosGetCallHeaderWithToken(
        apiUrl,
        "application/json", // Try with explicit content type
        { responseType: "blob" }, // Add responseType: 'blob' for file downloads
      );

      return response;
    } catch (error) {
      
      throw error; // Re-throw to be handled by caller
    }
  };

  const handleDownload = async () => {
    if (!startDate || !endDate) {
      setError("Please select both start and end dates");
      return;
    }

    if (startDate > endDate) {
      setError("Start date cannot be greater than end date.");
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Format dates for API request
      let formattedStartDate, formattedEndDate;

      if (typeof startDate === "string") {
        formattedStartDate = startDate.split("T")[0];
      } else if (startDate instanceof Date) {
        formattedStartDate = startDate.toISOString().split("T")[0];
      } else {
        formattedStartDate = startDate;
      }

      if (typeof endDate === "string") {
        formattedEndDate = endDate.split("T")[0];
      } else if (endDate instanceof Date) {
        formattedEndDate = endDate.toISOString().split("T")[0];
      } else {
        formattedEndDate = endDate;
      }

      const response = await getDownloadMaterialDashboard(
        formattedStartDate,
        formattedEndDate,
      );

      if (!response || !response.data) {
        throw new Error("No data received from the server");
      }

      // ── Empty file check ────────────────────────────────────────────
      const blob = new Blob([response.data]);
      if (blob.size === 0) {
        setError(
          "No records found for the selected date range. Please try a different date range.",
        );
        return;
      }
      // ───────────────────────────────────────────────────────────────

      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute(
        "download",
        `MaterialDashboard_${new Date().toISOString().split("T")[0]}.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (err) {
     

      try {
        if (err?.response?.data instanceof Blob) {
          const errorText = await err.response.data.text();
          const errorData = JSON.parse(errorText);
          setError(errorData?.message || "Failed to download dashboard.");
        } else {
          setError(
            err?.response?.data?.message ||
              err.message ||
              "Failed to download dashboard.",
          );
        }
      } catch (parseError) {
        
        setError("Failed to download dashboard.");
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    startDate,
    endDate,
    handleStartDateChange,
    handleEndDateChange,
    handleDownload,
    loading,
    error,
  };
};

export default MCTDashboardVM;
